const notificationCenter = {
  pageTitle: "Notification center",
  loading: "Loading notifications",
  tabs: {
    reporting: "Reporting",
    messages: "Messages",
    cases: "Cases",
    chargeInvoices: "Charge invoices",
    product: "Product",
    settings: "Settings",
    registrations: "Registrations",
    deadlines: "Deadlines",
  },
  sections: {
    reporting: {
      main: "Reporting",
    },
    messages: {
      main: "Messages",
    },
    cases: {
      main: "Cases",
    },
    chargeInvoices: {
      main: "Charge invoices",
    },
    product: {
      main: "Product",
    },
    settings: {
      main: "Settings",
    },
    registrations: {
      main: "Registrations",
    },
    deadlines: {
      main: "Deadlines",
    },
  },
  columns: {
    company: "Company",
    period: "Period",
    countryJurisdiction: "Country/Jurisdiction",
    typeOfReport: "Type of report",
    dueDate: "Due date",
    type: "Type",
    subject: "Subject",
    status: "Status",
    documents: "Documents",
    dateLastStatusChanged: "Date last status\nchanged",
    generatedBy: "Generated by",
    app: "App",
    description: "Description",
    amount: "Amount",
    typeOfNumber: "Type of number",
    jurisdiction: "Jurisdiction",
    date: "Date",
    companiesList: "Companies list",
    orderDate: "Order date",
    typeOfRegistration: "Type of registration",
    subcategoryOfRegistration: "Subcategory of\nregistration",
    estimateDateOfRegistration: "Estimate date of\nregistration",
    actions: "Actions",
  },
  actions: {
    openRequest: "Open request",
    viewDocumentRequestDetails: "View details",
    delete: "Delete",
  },
  documentRequestDrawer: {
    title: "Document request details",
    subject: "Subject",
    requestedOn: "Requested on",
    requestedBy: "Requested by",
    uploadedDocuments: "Uploaded documents ({{count}})",
    noDocuments: "No documents uploaded yet",
    openDocument: "Open document",
  },
  documents: {
    uploadedCount: "{{count}} uploaded",
    underReview: "Under review",
    awaitingDocuments: "Awaiting documents",
  },
  filters: {
    visibility: {
      mine: "Show mine",
      all: "Show all",
    },
    deadlinesPrefix: "Deadlines:",
    deadlines: {
      next3Days: "Next 3 days",
      forthcoming: "Forthcoming",
      all: "All",
      missed: "Missed",
    },
  },
  empty: {
    title: "No notifications",
    description: "There are no items in this section.",
    tabPlaceholder: "This section will be available soon.",
    noTablesForRole: "No notification sections are available for your account.",
  },
};

export default notificationCenter;
